/**
 * Button for clear filters - must be used inside listFilters
 */

app.directive("filterIco", function() {

    return {
        restrction: "E",
        require: '^^listFilters',
        link: function($scope, element, attrs, $ctrl) {

            $scope.isVisible = function() {

                return !$ctrl.areClear();

            };

        },
        scope: {

            onClick: "&"
        },
        templateUrl: "/assets/js/angular/components/directives/filters/filterico.html",
    }

});
